/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.

  document.addEventListener('DOMContentLoaded', () => {
    const loadMoreBtn = document.querySelector('.ajax-load-more-btn');
    const collectionGrid = document.querySelector('#CollectionLoop');

    if (!loadMoreBtn || !collectionGrid) return;

    let isLoading = false;
    let currentPreloadPromise = null;

    // 1. Fast Fetcher via Shopify Section API
    const fetchProducts = async (url, sectionId) => {
      try {
        const fetchUrl = new URL(url, window.location.origin);
        fetchUrl.searchParams.set('section_id', sectionId);

        const response = await fetch(fetchUrl.toString(), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newGrid = doc.querySelector('#CollectionLoop');
        const newBtn = doc.querySelector('.ajax-load-more-btn');

        return {
          html: newGrid ? newGrid.innerHTML : '',
          nextUrl: newBtn ? newBtn.getAttribute('data-next-url') : null
        };
      } catch (error) {
        console.error('[Load More Error]:', error);
        return null;
      }
    };

    // Helper to trigger background preload
    const startPreload = (url, sectionId) => {
      if (!url) return Promise.resolve(null);
      return fetchProducts(url, sectionId);
    };

    // 2. Start preloading page 2 immediately on page load
    const initialNextUrl = loadMoreBtn.getAttribute('data-next-url');
    const sectionId = loadMoreBtn.getAttribute('data-section-id');
    currentPreloadPromise = startPreload(initialNextUrl, sectionId);

    // 3. Click Event Listener
    loadMoreBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      if (isLoading) return;

      isLoading = true;

      const btnTextElement = loadMoreBtn.querySelector('.btn-text') || loadMoreBtn;
      const defaultText = loadMoreBtn.getAttribute('data-default-text') || 'Vis flere produkter';
      const loadingText = loadMoreBtn.getAttribute('data-load-text') || 'Indlæser...';

      // Instantly switch to loading text & disable button during request
      btnTextElement.textContent = loadingText;
      loadMoreBtn.disabled = true;
      loadMoreBtn.style.opacity = '0.7';

      // Wait for the background promise (instant if already preloaded)
      const data = await currentPreloadPromise;

      if (data && data.html) {
        // Append new products
        collectionGrid.insertAdjacentHTML('beforeend', data.html);

        // Trigger image lazyloading and layout adjustments
        window.dispatchEvent(new Event('resize'));
        window.dispatchEvent(new Event('scroll'));

        if (data.nextUrl) {
          // Update next URL attribute for the next click
          loadMoreBtn.setAttribute('data-next-url', data.nextUrl);
          
          // Reset button state back to original text
          btnTextElement.textContent = defaultText;
          loadMoreBtn.disabled = false;
          loadMoreBtn.style.opacity = '1';

          // Immediately start preloading the NEXT page in the background
          currentPreloadPromise = startPreload(data.nextUrl, sectionId);
        } else {
          // End of collection: replace button with end message
          const wrapper = loadMoreBtn.closest('.custom-pagination-wrapper') || loadMoreBtn.parentElement;
          wrapper.innerHTML = `<div class="no-more-products" style="padding: 20px 0; font-weight: bold; color: #666;">Ikke flere produkter</div>`;
        }
      } else {
        // Error Recovery: reset button state so the user can try clicking again
        btnTextElement.textContent = 'Fejl. Prøv igen.';
        loadMoreBtn.disabled = false;
        loadMoreBtn.style.opacity = '1';

        // Restart preload for the failed URL
        const currentUrl = loadMoreBtn.getAttribute('data-next-url');
        currentPreloadPromise = startPreload(currentUrl, sectionId);

        setTimeout(() => {
          btnTextElement.textContent = defaultText;
        }, 3000);
      }

      isLoading = false;
    });
  });


})();